import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import CloseIcon from '@mui/icons-material/Close';
import { siteOrigin } from '../native';

interface ShareModalProps {
  open: boolean;
  onClose: () => void;
  eventName: string;
}

const ShareModal: React.FC<ShareModalProps> = ({ open, onClose, eventName }) => (
  <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 3, background: '#18181c', color: '#fff', minWidth: 400 } }}>
    <DialogContent sx={{ p: 4, position: 'relative' }}>
      <IconButton onClick={onClose} sx={{ position: 'absolute', top: 16, right: 16, color: '#fff' }}>
        <CloseIcon />
      </IconButton>
      <Typography variant="h5" fontFamily="Cormorant Garamond, serif" fontWeight={700} mb={1}>
        {eventName}
      </Typography>
      <Typography variant="subtitle2" sx={{ color: '#c9a227', mb: 3 }}>
        Invite your friends
      </Typography>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <button style={{ display: 'flex', alignItems: 'center', gap: '12px', background: '#23232a', border: 'none', borderRadius: '8px', padding: '16px', color: '#fff', fontWeight: 600, fontSize: '16px', cursor: 'pointer' }}
          onClick={() => window.open(`https://www.facebook.com/dialog/share?app_id=145634995501895&display=popup&href=${encodeURIComponent(`${siteOrigin()}${window.location.pathname}`)}&quote=${encodeURIComponent('Join me at ' + eventName + '! Found on Cheers2Night.')}`, '_blank', 'width=600,height=400')}
        >
          <FacebookIcon sx={{ fontSize: 32, color: '#1877F2' }} />
          Tag Friends on Facebook
        </button>
        <button style={{ display: 'flex', alignItems: 'center', gap: '12px', background: '#23232a', border: 'none', borderRadius: '8px', padding: '16px', color: '#fff', fontWeight: 600, fontSize: '16px', cursor: 'pointer' }}
          onClick={() => window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent('Join me at ' + eventName + '! Found on Cheers2Night. ' + siteOrigin() + window.location.pathname)}`, '_blank')}
        >
          <WhatsAppIcon sx={{ fontSize: 32, color: '#25D366' }} />
          Invite via WhatsApp
        </button>
      </div>
    </DialogContent>
  </Dialog>
);

export default ShareModal;
